import { takeLatest, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  saveAddress,
  saveWhatsAppNo,
  saveMinimumOrderQty,
  savePaymentMode,
  savePaymentGateway,
  saveSipMode,
  saveSipStatus,
  addSms,
  saveKycStatus,
  setMessage,
  setError,
  getConfiguration,
  setConfiguration,
  getAppConfiguration,
  setAppConfiguration,
  updateAppConfigFields,
  bulkDiamondPointGiftByFileRequest,
  bulkDiamondPointGiftByPhoneRequest,
  saveDiamondPointsExpireRequest,
  saveDiamondPointsAmountConfigRequest,
} from '../slices/settingSlice';

function* handleSaveAddress(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getConfiguration`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("Address added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add Address'));
  }
}

function* handleSaveWhatsAppNo(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveWhatsappNumber`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("Number added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add Number'));
  }
}

function* handleOfflineOrderLimit(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveMinimumOrderQty`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("Order Limit added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to Order Limit'));
  }
}

function* handleSavePaymentMode(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/savePaymentMode`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("Payment Mode added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add Payment Mode'));
  }
}

function* handleSavePaymentGateway(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/savePaymentGateway`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("Payment Gateway added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add Payment Gateway'));
  }
}

function* handleSaveSipPayment(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveSipMode`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("saveSipMode added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add saveSipMode'));
  }
}

function* handleSaveSipStatus(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveMoneySipMode`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("saveMoneySipMode added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add saveMoneySipMode'));
  }
}

function* handleAddSMS(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/addSms`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("SMS quantity added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add SMS quantity'));
  }
}

function* handleSaveKycStatus(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/jewellerKycStatus`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("KYC Status added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add KYC Status'));
  }
}

function* handleGetConfiguration(action) {
  try {
    let payload = action.payload;
    console.log("action.==", payload);
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getConfiguration`,
      action.payload
    );
    console.log("res", res.data.errormsg);
    if (res?.data?.errormsg) {
      yield put(setError(res.data.errormsg || "Something wrong!"));
      return;
    }
    yield put(setConfiguration(res.data));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to get metal"));
  }
}

function* handleGetAppConfiguration(action) {
  try {
    let payload = action.payload;
    console.log("action.==", payload);
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getAppConfiguration`,
      action.payload
    );
    console.log("res", res.data.errormsg);
    if (res?.data?.errormsg) {
      yield put(setError(res.data.errormsg || "Something wrong!"));
      return;
    }
    yield put(setAppConfiguration(res.data));
  } catch (err) {
    yield put(setError(err.response?.data?.message || "Failed to  getAppConfiguration"));
  }
}

function* handleUpdateAppConfigFields(action) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/updateAppFields`, action.payload);
    
    console.log("res", res.data.errormsg)
    if(res?.data?.errormsg) {
        yield put(setError(res.data.errormsg || 'Something went wrong!'));
        return
    }
    yield put(setMessage("update App Fields added successfully"));
  } catch (err) {
    yield put(setError(err.response?.data?.message || 'Failed to add Update App Fields'));
  }
}
function* handleBulkDiamondPointGiftByFile(action) {
  try {
    let formData=new FormData();
      formData.append("type", action.payload.trimmedType);
      formData.append("unit", action.payload.trimmedUnit);
      formData.append("note", action.payload.bulkGiftNote1);
      formData.append("file", action.payload.bulkGiftFile);


    const res = yield axios.post(
    //  `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/bulkpoints`
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/customer/bulkpoints`,

      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (res?.data?.errormsg) {
      yield put(setError(res.data.errormsg || "Something went wrong!"));
      return;
    }

    yield put(setMessage("Bulk Diamond Point Gift uploaded successfully"));
  } catch (err) {
    console.log("error",err)
    yield put(
      setError(err.response?.data?.message || "Failed to upload bulk diamond gift")
    );
  }
}
function* handleBulkDiamondPointGiftByPhone(action) {
  try {
    const res = yield axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/customer/bulkpointsbyphone`, { data: action.payload } );

    if (res?.data?.errormsg) {
      yield put(setError(res.data.errormsg || "Something went wrong!"));
      return;
    }

    yield put(setMessage("Bulk Diamond Point Gift By Phone uploaded successfully"));
  } catch (err) {
    yield put(
      setError(err.response?.data?.message || "Failed to upload bulk diamond gift by phone")
    );
  }
}

function* handleSaveDiamondPointsExpire(action){
  try {
    const res=yield axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveofferdetails`,
      {
        name:"diamondpointstoexpire",
        value:{
          expireUnitType:action.payload.expireUnitType,
          expireUnit:action.payload.expireUnit  
        },
      }
    );
      if(res?.data?.errormsg){
        yield put(setError(res.data.errormsg || "Something went wrong!"));
        return;
      }
        yield put(setMessage("Diamond Points Expiry saved successfully"));
      if(action.payload.callback){
        action.payload.callback(res.data);
      }  
  } catch (error) {
    yield put(
      setError(error.response?.data?.message || "Failed to save diamond points expiry")
    );
  }
}
function* handleSaveDiamondPointsAmountConfig(action){
  try {
    const res=yield axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveofferdetails`,
      {
        name:"diamondpointsamountconfig",
        value:{
          amountType:action.payload.amountType,
          configAmount:action.payload.configAmount  
        },
      }
    );
      if(res?.data?.errormsg){
        yield put(setError(res.data.errormsg || "Something went wrong!"));
        return;
      }
        yield put(setMessage("Diamond Points Amount Config saved successfully"));
      if(action.payload.callback){
        action.payload.callback(res.data);
      }  
  } catch (error) {
    yield put(
      setError(error.response?.data?.message || "Failed to save diamond points amount config")
    );
  }
}


export function* settingSaga() {
   yield takeLatest(saveAddress.type, handleSaveAddress);
   yield takeLatest(saveWhatsAppNo.type, handleSaveWhatsAppNo);
   yield takeLatest(saveMinimumOrderQty.type, handleOfflineOrderLimit);
   yield takeLatest(savePaymentMode.type, handleSavePaymentMode);
   yield takeLatest(savePaymentGateway.type, handleSavePaymentGateway);
   yield takeLatest(saveSipMode.type, handleSaveSipPayment);
   yield takeLatest(saveSipStatus.type, handleSaveSipStatus);
   yield takeLatest(addSms.type, handleAddSMS);
   yield takeLatest(saveKycStatus.type, handleSaveKycStatus);
   yield takeLatest(getConfiguration.type, handleGetConfiguration);
   yield takeLatest(getAppConfiguration.type, handleGetAppConfiguration);
   yield takeLatest(updateAppConfigFields.type, handleUpdateAppConfigFields);
   yield takeLatest(bulkDiamondPointGiftByFileRequest.type, handleBulkDiamondPointGiftByFile);
   yield takeLatest(bulkDiamondPointGiftByPhoneRequest.type, handleBulkDiamondPointGiftByPhone);
   yield takeLatest(saveDiamondPointsExpireRequest.type, handleSaveDiamondPointsExpire);
   yield takeLatest(saveDiamondPointsAmountConfigRequest.type, handleSaveDiamondPointsAmountConfig);
}

